import React from "react";
import { Menu } from "antd";
import {
    PieChartOutlined,
    ShopOutlined,
    ClusterOutlined,
    PartitionOutlined,
    RetweetOutlined,
    SecurityScanOutlined,
    AlertOutlined,
    MessageOutlined,
    CheckCircleOutlined,
    RollbackOutlined,
    DollarCircleOutlined,
    UnorderedListOutlined,
    ScheduleOutlined,
    ReconciliationOutlined,SettingOutlined,ContainerOutlined,BarsOutlined,FileAddOutlined,ScanOutlined,FileTextOutlined
    // LinkOutlined,
} from "@ant-design/icons";
import GroupAccess from "./../../helper/GroupAccess";
import MenuAccess from "./../../helper/MenuAccess";
import AssociationsChecker from "./../../helper/AssociationsChecker";
import { THEME, DISABLE_OI, DISABLE_CBM, DISABLE_ALERTS, DISABLE_PAYMENTS, DISABLE_TXALERT2, DISPLAY_PAYMENT_LINK, DISABLE_THREEDS_MICROSERVICE, DISPLAY_USER_MESSAGES, DISABLE_CHARGEBACKS, DISABLE_DOMAIN_MONITOR, DISABLE_ALERT_REPORTING_SECTION } from "../../config/config";
import Pdf from '../../PreDisputeAlertHandlingAndDashboardGuideJune2024.pdf';
import UserMessages from "../../helper/UserMessages";
import EnrollmentChecker from "./../../helper/ServiceEnrollmentChecker";

const Sidebar = (props) => {

    if(DISPLAY_USER_MESSAGES) {
        UserMessages(); // show message notifications
    }

    const { t, theme, pathname } = props;

    const getDefaultSelectedKeys = () => {
        if (pathname === '/') {
            return "dashboard";
        }
        const keys = pathname.substring(1).split("/");
    
        if (keys.length === 1) {
            return keys[0];
        }

        switch (keys[0]) {
            case "merchant":
                return "merchants";
            case "alert":
                return "alerts";
            case "credit_report":
                return "credit_report";
            case "alertdescriptor":
                return "alertdescriptors";
            case "descriptorvariation":
                return "descriptorvariations";
            case "txfind_cart":
                return "txfind_carts";
            case "txfind_descriptor":
                return "txfind_descriptors";
            case "txalertmenu":
                return "txalertmenu";
            case "txfind_bincaids":
                return "txfind_bincaids";
            case "txfind":
                return keys[1] || "txfind"; // This will handle sub-routes of txfind
            case "domain":
                return "domains";
            case "monitoring_alerts":
                return "monitoring_alerts";
            default:
                return keys[0];
        }
    };

    const getDefaultOpenKeys = () => {
        const keyname = pathname.substring(1).split("/")[0];
//console.log(keyname);
        if (
            keyname === "transactions" ||
            keyname === "refunds" ||
            keyname === "virtualterminal" ||
            keyname === "virtualterminal-cliq-cc" ||
            keyname === "virtualterminal-cliq-ach" ||
            keyname === "balance" 
        ) {
            return ['tx'];
        }
        if (
            keyname === "3dsecure" || 
            keyname === "3dsstats" || 
            keyname === "3dsecure_overview" ||
            keyname === "3dsecure_merchant" ||
            keyname === "3dsbinmid"
        ) {
            return ['3ds_microservice'];
        }
        // if( remove support for old 3ds - https://app.clickup.com/t/86cz0pj9y
        //     keyname === "3ds_transaction"
        // ){
        //     return ['3ds'];
        // }
        if (
            keyname === "cliq_operations_report" ||
            keyname === "alert_resolution_report"
        ) {
            return ['alertmenu', 'reports'];
        }
        if (
            keyname === "alerts" ||
            keyname === "alert" ||
            keyname === "bincaiddescriptors" ||
            keyname === "credit_report" ||
            keyname === "alertstats" ||
            keyname === "rdractivity"||
            keyname === "descriptorenrollments"
        ) {
            return ['alertmenu'];
        }
        if(
            keyname === 'alertdescriptors' ||
            keyname === 'alertdescriptor'  ||
            keyname === "descriptorvariations"
        ) {
            return ['alertmenu','alertdescriptorsparent'];
        }
        if (
            keyname === "cbm_merchants" ||
            keyname === "cbm_providers" ||
            keyname === "cbm_merchant_providers" ||
            keyname === "cbm" ||
            keyname === "cbm_alertproviders" ||
            keyname === "cbm_alertprovider_logins"
        ) {
            return ['cbm_menus'];
        }
        if (
            keyname === "chargeback"
        ) {
            return ['chargeback_menu'];
        }
        if (
            keyname === "txfind_merchants" ||
            keyname === "txfind_descriptors" ||
            keyname === "txfind_bincaids" ||
            keyname === "txfind_carts" ||
            keyname === "txfind_carts_lookup" ||
            keyname === "txfind" || 
            keyname === "txfind_ce_lookup" ||
            keyname === "txfind_notifications" ||
            keyname === "txfind_rdr_decisions"
        ) {
            return ['txfind'];
        }
        if (
            keyname === "alertlist" || 
            keyname === "alertdetail" || 
            keyname === "descriptorlist" || 
            keyname === "descriptor" || 
            keyname === "bincaidlist" ||
            keyname === "bincaid" ||
            keyname === "merchantlist" ||
            keyname === "merchantdetails"
           
        ) {
            return ['txalertmenu'];
        }
        if( 
            keyname === "enrollmentstatuslist" ||
            keyname === "disputeconditioncodelist" ||
            keyname === "alerttypelist" ||
            keyname === "creditreasonlist" ||
            keyname === "creditstatuslist" ||
            keyname === "mcctierlist"  ||
            keyname === "alertproviderlist" ||
            keyname === "alertproviderdeatil" ||
            keyname === "alertproviderlogins" ||
            keyname === "erproviderlist" ||
            keyname === "erproviderlogins" ||
            keyname === "alertresponses" ||
            keyname === "acquiringbanklist" ||
            keyname === "acquiringbankaccountlist" || 
            keyname === "ertransactionmatches" ||
            keyname === "ertransactionmatch" ||
            keyname === "creditrequests" ||
            keyname === "themelist" ||
            keyname === "emailtemplatelist" ||
            keyname === "generatealert" ||
            keyname === "issuerbinlist"
            ){
                return ['txalertmenu','txalert_admin'];
        }
        if(
            keyname === "posttoalertproviderlogs" ||
            keyname === "posttomerchantlogs" ||
            keyname === "posttomerchantretrylogs" ||
            keyname === "posttoalertproviderretrylogs" ||
            keyname === "emailsendlogs" ||
            keyname === "backgroundprocesslogs"
            ){
                return ['txalertmenu','txalert_logs'];
        }
        if (
            keyname === "domains" ||
            keyname === "domain" ||
            keyname === "monitoring_alerts" ||
            keyname === "domain_monitor_users"
        ) {
            return ['domain_monitor'];
        }
    };

    const ItemAccess = (condition) => ({ className: condition === true ?  "":"d-none" });

    const ItemLabel = (href, text) => ({
        label: (
            <a className="nav-link" href={href}>
                <span>{text}</span>
            </a>
        ),
    });

    const UserGuideLabel = () => ({
        label: (
            <a className="nav-link" href = {Pdf} target = "_blank" rel="noopener noreferrer">
                <span>{t("sidebar.userguide")}</span>
            </a>
        ),
    });


    let menuItems = [
        {
            key: "dashboard",
            icon: <PieChartOutlined />,
            ...ItemLabel("/dashboard", t("sidebar.dashboard")),
            ...ItemAccess(!GroupAccess("VIEW REPORT ONLY")),
        },
        {
            key: "merchants",
            icon: <ShopOutlined />,
            ...ItemLabel("/merchants", t("sidebar.merchants")),
            ...ItemAccess(GroupAccess("SYSADMIN|RESELLER|MERCHANT") && MenuAccess('merchants') && !GroupAccess("VIEW REPORT ONLY")),
        },
        {
            key: "tx",
            icon: <RetweetOutlined />,
            label: t("sidebar.payments"),
            children: [
                {
                    key: "transactions",
                    ...ItemLabel("/transactions", t("sidebar.transactions")),
                },
                {
                    key: "virtualterminal",
                    ...ItemLabel("/virtualterminal", t("sidebar.virtual_terminal")),
                    ...ItemAccess(THEME.toLowerCase() !== "cliq" && MenuAccess('virtualterminal')),
                },
                {
                    key: "virtualterminal-cliq-cc",
                    ...ItemLabel("/virtualterminal-cliq-cc", t("sidebar.virtualterminal-cliq-cc")),
                    ...ItemAccess(THEME.toLowerCase() === "cliq" && MenuAccess('virtualterminal')),
                },
                {
                    key: "virtualterminal-cliq-ach",
                    ...ItemLabel("/virtualterminal-cliq-ach", t("sidebar.virtualterminal-cliq-ach")),
                    ...ItemAccess(THEME.toLowerCase() === "cliq" && MenuAccess('virtualterminal')),
                },
                {
                    key: "balance",
                    // icon: <SecurityScanOutlined />,
                    ...ItemLabel("/balance", t("sidebar.balance")),
                    ...ItemAccess(GroupAccess("SYSADMIN|RESELLER|MERCHANT")),
                },
                {
                    key: 'Payment Links',
                    ...ItemLabel("/paymentlink", t("sidebar.paymentlink")),
                    ...ItemAccess(DISPLAY_PAYMENT_LINK),
                }

            ],
            ...ItemAccess(MenuAccess('payments') && !DISABLE_PAYMENTS && !GroupAccess("VIEW REPORT ONLY")),
        },
        {
            key: "fraudchecks",
            icon: <SecurityScanOutlined />,
            ...ItemLabel("/fraudchecks", t("sidebar.fraudchecks")),
            ...ItemAccess(MenuAccess('fraudchecks') && !GroupAccess("VIEW REPORT ONLY")),
        },
        {
            key: "3ds_microservice",
            icon: <CheckCircleOutlined />,
            label: t("sidebar.3dsecure_microservice"),
            children: [
                {
                    key: "3dsecure_overview",
                    ...ItemLabel("/3dsecure_overview", t("sidebar.3dsecure_overview")),
                },
                {
                    key: "3dsstats",
                    ...ItemLabel("/3dsstats", t("sidebar.statistics")),
                },
                {
                    key: "3dsecure_merchant",
                    ...ItemLabel("/3dsecure_merchant", t("sidebar.3dsecure_merchant")),
                },
                {
                    key: "3dsecure",
                    ...ItemLabel("/3dsecure", t("sidebar.transactions")),
                },
                {
                    key: "3dsbinmid",
                    ...ItemLabel("/3dsbinmid", t("sidebar.binmid")),
                },
            ],
            ...ItemAccess((GroupAccess("SYSADMIN") || AssociationsChecker("THREEDS")) && !DISABLE_THREEDS_MICROSERVICE && !GroupAccess("VIEW REPORT ONLY")),
        },
        {
            key: "alertmenu",
            icon: <AlertOutlined />,
            label: t("sidebar.alerts"),
            children: [
                {
                    key: "alerts",
                    icon: <AlertOutlined />,
                    ...ItemLabel("/alerts", t("sidebar.alerts")),
                    ...ItemAccess(!GroupAccess("VIEW REPORT ONLY")),
                },
                {
                    key: "alertdescriptorsparent",
                    icon: <ClusterOutlined />,
                    label:t("sidebar.descriptors"),
                    ...ItemAccess(!GroupAccess("VIEW REPORT ONLY")),
                    children:[
                        {
                            key: "alertdescriptors",
                            icon: <ClusterOutlined />,
                            ...ItemLabel("/alertdescriptors", t("sidebar.descriptors"))
                        },
                        {
                            key: "descriptorvariations",
                            icon: <PartitionOutlined />,
                            ...ItemLabel("/descriptorvariations", t("sidebar.descriptorvariations")),
                        },
                        {
                            key: "descriptorenrollments",
                            icon: <FileAddOutlined />,
                            ...ItemAccess(GroupAccess("SYSADMIN|ACCESS ENROLLMENTS")),
                            ...ItemLabel("/descriptorenrollments", t("sidebar.descriptorenrollments")),
                        },
                    ]
                    
                },
               
                {
                    key: "bincaiddescriptors",
                    icon: <ReconciliationOutlined />,
                    ...ItemLabel("/bincaiddescriptors", t("sidebar.bincaiddescriptors")),
                    ...ItemAccess(!GroupAccess("VIEW REPORT ONLY")),
                },
                {
                    key: "alertstats",
                    icon: <UnorderedListOutlined />,
                    ...ItemLabel("/alertstats", t("sidebar.statistics")),                           
                    ...ItemAccess(GroupAccess("SYSADMIN|MERCHANT") && !GroupAccess("VIEW REPORT ONLY")),
                },
                {
                    key: "rdractivity",
                    icon: <UnorderedListOutlined />,
                    ...ItemLabel("/rdractivity", t("sidebar.rdractivity")),
                    ...ItemAccess(GroupAccess("SYSADMIN|MERCHANT") && !GroupAccess("VIEW REPORT ONLY")),
                },
                {
                    key: "credit_report",
                    icon: <ScheduleOutlined />,
                    ...ItemLabel("/credit_report", t("sidebar.credit_report")),
                    ...ItemAccess(!GroupAccess("VIEW REPORT ONLY")),
                },
                {
                    key: "reports",
                    icon: <FileTextOutlined />,
                    label: t("sidebar.reports"),
                    // Section visible if the user can see at least one child report.
                    ...ItemAccess(GroupAccess("SYSADMIN|CUSTOM ALERT REPORTS|VIEW REPORT ONLY") && !DISABLE_ALERT_REPORTING_SECTION),
                    children: [
                        {
                            // Existing report — unchanged gating (group-based).
                            key: "cliq_operations_report",
                            icon: <FileTextOutlined />,
                            ...ItemLabel("/cliq_operations_report", t("sidebar.cliq_operations_report")),
                            ...ItemAccess(GroupAccess("SYSADMIN|CUSTOM ALERT REPORTS")),
                        },
                        {
                            // New report — gated by the "VIEW REPORT ONLY" group.
                            key: "alert_resolution_report",
                            icon: <FileTextOutlined />,
                            ...ItemLabel("/alert_resolution_report", t("sidebar.alert_resolution_report")),
                            ...ItemAccess(GroupAccess("SYSADMIN|CUSTOM ALERT REPORTS|VIEW REPORT ONLY")),
                        },
                    ],
                },
                {
                    key: "userguide",
                    icon: <MessageOutlined />,
                    ...UserGuideLabel(),
                    ...ItemAccess(THEME.toLowerCase() === "default" && !GroupAccess("VIEW REPORT ONLY")),
                },
            ],
            ...ItemAccess((MenuAccess('alerts') || GroupAccess("VIEW REPORT ONLY")) && !DISABLE_ALERTS),
        },
        {
            key: "messages",
            icon: <MessageOutlined />,
            ...ItemLabel("/messages", t("sidebar.messages")),
            ...ItemAccess(MenuAccess('messages') && !GroupAccess("VIEW REPORT ONLY")),
        },
        {
            key: "txalertmenu",
            icon: <AlertOutlined />,
            label: t("sidebar.txalert"),
            ...ItemAccess(!DISABLE_TXALERT2 && !GroupAccess("VIEW REPORT ONLY")),
            children: [
                {
                    key: "alertlist",
                    icon: <AlertOutlined />,
                    ...ItemLabel("/alertlist", t("sidebar.alerts")),
                },
                {
                    key: "descriptorlist",
                    icon: <ClusterOutlined />,
                    ...ItemLabel("/descriptorlist", t("sidebar.descriptors")),
                },
                {
                    key: "bincaidlist",
                    icon: <ReconciliationOutlined />,
                    ...ItemLabel("/bincaidlist", t("sidebar.bincaiddescriptors")),
                },
                {
                    key: "merchantlist",
                    icon: <ShopOutlined />,
                    ...ItemLabel("/merchantlist", t("sidebar.merchants")),
                    ...ItemAccess(GroupAccess("SYSADMIN|MERCHANT")),
                },
                {
                    key: "txalert_admin",
                    icon: <SettingOutlined />,
                    label:  t("sidebar.admin"),
                    ...ItemAccess(GroupAccess("SYSADMIN")),
                    children: [
                        {
                            key: "acquiringbanklist",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/acquiringbanklist", t("sidebar.acquiringbanklist")),
                        },
                        {
                            key: "acquiringbankaccountlist",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/acquiringbankaccountlist", t("sidebar.acquiringbankaccountlist")),
                        },
                        {
                            key: "alertproviderlist",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/alertproviderlist", t("sidebar.alertproviders")),
                        },
                        {
                            key: "alertproviderlogins",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/alertproviderlogins", t("sidebar.alertproviderlogins")),
                        },
                        {
                            key: "enrollmentstatuslist",
                            icon: <BarsOutlined />,
                            ...ItemLabel("/enrollmentstatuslist", t("sidebar.enrollmentstatuslist"))
                        },
                        {
                            key: "disputeconditioncodelist",
                            icon: <BarsOutlined />,
                            ...ItemLabel("/disputeconditioncodelist", t("sidebar.disputeconditioncodelist"))
                        },
                        {
                            key: "alerttypelist",
                            icon: <ContainerOutlined />,
                            ...ItemLabel("/alerttypelist", t("sidebar.alerttypelist"))
                        },
                        {
                            key: "creditrequests",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/creditrequests", t("sidebar.creditrequests")),
                        },
                        {
                            key: "creditreasonlist",
                            icon: <ContainerOutlined />,
                            ...ItemLabel("/creditreasonlist", t("sidebar.creditreasonlist"))
                        },
                        {
                            key: "creditstatuslist",
                            icon: <ContainerOutlined />,
                            ...ItemLabel("/creditstatuslist", t("sidebar.creditstatuslist"))
                        },
                        {
                            key: "mcctierlist",
                            icon: <ContainerOutlined />,
                            ...ItemLabel("/mcctierlist", t("sidebar.mcctierlist"))
                        },
                        {
                            key: "erproviderlist",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/erproviderlist", t("sidebar.erproviders")),
                        },
                        {
                            key: "erproviderlogins",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/erproviderlogins", t("sidebar.erproviderlogins")),
                        },
                        {
                            key: "alertresponses",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/alertresponses", t("sidebar.alertresponses")),
                        },
                        {
                            key: "ertransactionmatches",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/ertransactionmatches", t("sidebar.ertransactionmatches")),
                        },
                        {
                            key: "themelist",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/themelist", t("sidebar.themelist")),
                        },
                        {
                            key: "emailtemplatelist",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/emailtemplatelist", t("sidebar.emailtemplatelist")),
                        },
                        {
                            key: "issuerbinlist",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/issuerbinlist", t("sidebar.issuerbinlist")),
                        },
                        {
                            key: "generatealert",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/generatealert", t("sidebar.generatealert")),
                        }]
                },
                {
                    key: "txalert_logs",
                    icon: <SettingOutlined />,
                    label:  t("sidebar.logs"),
                    children: [                        
                        {
                            key: "posttoalertproviderlogs",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/posttoalertproviderlogs", t("sidebar.posttoalertproviderlogs")),                            
                            ...ItemAccess(GroupAccess("SYSADMIN")),
                        },
                        {
                            key: "posttomerchantlogs",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/posttomerchantlogs", t("sidebar.posttomerchantlogs")),                            
                            ...ItemAccess(GroupAccess("SYSADMIN|MERCHANT")),
                        },
                        {
                            key: "posttoalertproviderretrylogs",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/posttoalertproviderretrylogs", t("sidebar.posttoalertproviderretrylogs")),                            
                            ...ItemAccess(GroupAccess("SYSADMIN")),
                        },
                        {
                            key: "posttomerchantretrylogs",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/posttomerchantretrylogs", t("sidebar.posttomerchantretrylogs")),                            
                            ...ItemAccess(GroupAccess("SYSADMIN|MERCHANT")),
                        },
                        {
                            key: "emailsendlogs",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/emailsendlogs", t("sidebar.emailsendlogs")),                            
                            ...ItemAccess(GroupAccess("SYSADMIN")),
                        },
                        {
                            key: "backgroundprocesslogs",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/backgroundprocesslogs", t("sidebar.backgroundprocesslogs")),                            
                            ...ItemAccess(GroupAccess("SYSADMIN")),
                        },
                        {
                            key: "expressresolvelogs",
                            icon: <ShopOutlined />,
                            ...ItemLabel("/expressresolvelogs", t("sidebar.expressresolvelogs")),
                            ...ItemAccess(GroupAccess("SYSADMIN")),
                        },]
                    }
            ],
        },
        {
            key: "cbm_menus",
            icon: <RollbackOutlined />,
            label: t("sidebar.cbm"),
            children: [
                {
                    key: "cbm_merchants",
                    ...ItemLabel("/cbm_merchants", t("sidebar.merchants")),
                    ...ItemAccess(GroupAccess("SYSADMIN") || AssociationsChecker("CBM")),
                },
                {
                    key: "cbm_providers",
                    ...ItemLabel("/cbm_providers", t("sidebar.providers")),
                    ...ItemAccess(GroupAccess("SYSADMIN")),
                },
                {
                    key: "cbm_merchant_providers",
                    ...ItemLabel("/cbm_merchant_providers", t("sidebar.merchant_providers")),
                    ...ItemAccess(GroupAccess("SYSADMIN")),
                },
                {
                    key: "cbm",
                    ...ItemLabel("/cbm", t("sidebar.chargebacks")),
                },
                {
                    key: "cbm_alertproviders",
                    ...ItemLabel("/cbm_alertproviders", t("sidebar.alertproviders")),
                    ...ItemAccess(GroupAccess("SYSADMIN")),
                },
                {
                    key: "cbm_alertprovider_logins",
                    ...ItemLabel("/cbm_alertprovider_logins", t("sidebar.merchantalertproviders")),
                    ...ItemAccess(GroupAccess("SYSADMIN")),
                }
            ],
            ...ItemAccess((GroupAccess("SYSADMIN") || AssociationsChecker("CBM")) && !DISABLE_CBM && MenuAccess('cbm') && !GroupAccess("VIEW REPORT ONLY")),
        },

        {
            key: "chargeback_menu",
            icon: <RollbackOutlined />,
            label: t("sidebar.chargeback"),
            children: [
                {
                    key: "chargeback",
                    ...ItemLabel("/chargeback", t("sidebar.chargebacks")),
                },
            ],
            ...ItemAccess((GroupAccess("SYSADMIN") || AssociationsChecker("CBM")) && !DISABLE_CHARGEBACKS && MenuAccess('cbm') && !GroupAccess("VIEW REPORT ONLY")),
        },

        {
            key: "txfind",
            icon: <DollarCircleOutlined />,
            label: t("sidebar.order_insight"),
            ...ItemAccess((GroupAccess("SYSADMIN") || AssociationsChecker("OI")) && !DISABLE_OI && MenuAccess('order_insights') && !GroupAccess("VIEW REPORT ONLY")),
            children: [
              {
                key: "txfind_merchants",
                ...ItemLabel("/txfind_merchants", t("sidebar.merchants")),
              },
              //commenting as these are not in use in the current workflow
            /*  {
                key: "txfind_descriptors",
                ...ItemLabel("/txfind_descriptors", t("sidebar.descriptors")),
              },
              {
                key: "txfind_bincaids",
                ...ItemLabel("/txfind_bincaids", t("sidebar.bincaids")),
              },*/
              {
                key: "txfind_carts",
                ...ItemLabel("/txfind_carts", t("sidebar.carts")),
               ...ItemAccess(EnrollmentChecker("oiEnrollments",["OI", "CE", "EMS"])),
              },
              {
                key: "txfind_carts_lookup",
                ...ItemLabel("/txfind_carts_lookup", t("sidebar.lookup")),
                ...ItemAccess(EnrollmentChecker("oiEnrollments",["OI", "CE", "EMS"]))
              },
              {
                key: "txfind_notifications",
                ...ItemLabel("/txfind_notifications", t("sidebar.notifications")),
                ...ItemAccess(EnrollmentChecker("oiEnrollments",["Notices"]))
              },
              {
                key: "txfind_rdr_decisions",
                ...ItemLabel("/txfind_rdr_decisions", t("sidebar.rdr_decisions")),
                ...ItemAccess(EnrollmentChecker("oiEnrollments",["RDR Decision"])),
              }
            ],
          },
        {
            key: "domain_monitor",
            icon: <ScanOutlined />,
            label: t("domain_monitor.page_subtitle"),
            ...ItemAccess((GroupAccess("SYSADMIN") || GroupAccess("MERCHANT")) && !DISABLE_DOMAIN_MONITOR && MenuAccess('domain_monitoring_service') && !GroupAccess("VIEW REPORT ONLY")),
            children: [
                {
                    key: "domains",
                    ...ItemLabel("/domains", t("sidebar.domains")),
                },
                {
                    key: "monitoring_alerts",
                    ...ItemLabel("/monitoring_alerts", t("sidebar.monitoring_alerts")),
                },
                {
                    // Domain Monitor users (merchants/resellers/clients) — SYSADMIN only,
                    // mirrors txshield admin domain_monitor_users.php.
                    key: "domain_monitor_users",
                    ...ItemLabel("/domain_monitor_users", t("sidebar.domain_monitor_users")),
                    ...ItemAccess(GroupAccess("SYSADMIN")),
                }
            ],
            
        },
    ];

    return (
        <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={[getDefaultSelectedKeys()]}
            defaultOpenKeys={getDefaultOpenKeys()}
            style={{ borderRight: 0, backgroundColor: theme }}
            items={menuItems}
            _internalRenderMenuItem={node =>
                React.cloneElement(node, {
                  style: {
                    ...node.props.style,
                    backgroundColor: theme,
                  },
                })
              }
            
        />
    );
};

export default Sidebar;
